export interface ICardMenuConsorcio {
  title: string;
  subTitle?: string;
  description: string;
  statusIcon: StatusIcon;
  textIcon: "Assinatura pendente" | "Pagamento pendente" | "Contratado";
  idProduto: number;
  idDocumento: number;
  descriptionSecondLine?: string;
}

export interface IGetSubTitle {
  boletoPago: string;
  contratoAssinado: string;
}

export enum StatusIcon {
  progress = "progress",
  warning = "warning",
  success = "success",
}
